import { UiSchema } from '@rjsf/utils'

import { FormProperties } from '../imup/types'

export const uiSchema: UiSchema = {
    'ui:order': ['type', 'name', 'floorLevel', 'scale', 'option'],
    name: {
        'ui:title': 'Name',
        'ui:placeholder': 'Select Name',
    },
    type: {
        'ui:title': 'Type',
        'ui:placeholder': 'Select Type',
    },
    floorLevel: {
        'ui:title': 'Floor',
        'ui:placeholder': 'Select Floor',
    },
    scale: {
        'ui:title': 'Scale',
        'ui:placeholder': 'Select Scale',
    },
    option: {
        'ui:title': 'Classification',
        'ui:placeholder': 'Select Classification type',
    },
}

const onValidate = () => {}

const onSubmit = (settings, formData) => {
    return {
        ...settings,
        ...formData,
    }
}

const form: FormProperties = { uiSchema, onValidate, onSubmit }

export default form
